"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingText = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var hooks_1 = require("../../accessibility/hooks");
var Base_1 = require("./Base");
var StyledHeadingText = (0, styled_components_1.default)(Base_1.Base)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  line-height: 130%;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  font-family: ", ";\n  line-height: 130%;\n\n  &:focus {\n    outline: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "".concat(theme.typography.headingText.fontFamily, ", verdana, sans-serif");
});
/**
 * Our standard heading component, used when creating heading text. Defaults to a `H2`.
 *
 * Unless disabled, the Heading component will apply responsive styling across our default, XS, S and M breakpoints
 */
exports.HeadingText = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.level, level = _b === void 0 ? 2 : _b, _c = _a.sizes, sizes = _c === void 0 ? [
        design_system_theme_1.FontSizes.fontSize16,
        design_system_theme_1.FontSizes.fontSize20,
        design_system_theme_1.FontSizes.fontSize24,
        design_system_theme_1.FontSizes.fontSize28,
    ] : _c, _d = _a.align, align = _d === void 0 ? 'left' : _d, weight = _a.weight, color = _a.color, _e = _a.accessibilityAutoFocus, accessibilityAutoFocus = _e === void 0 ? false : _e, className = _a.className, children = _a.children, props = __rest(_a, ["level", "sizes", "align", "weight", "color", "accessibilityAutoFocus", "className", "children"]);
    var theme = (0, styled_components_1.useTheme)();
    var headerRef = (0, react_1.useRef)(null);
    (0, hooks_1.useAssignFocus)(headerRef, accessibilityAutoFocus);
    return (react_1.default.createElement(StyledHeadingText, __assign({ sizes: sizes, align: align, color: color !== null && color !== void 0 ? color : theme.colors.text.primary, weight: weight !== null && weight !== void 0 ? weight : theme.typography.fontWeights.regular, ref: accessibilityAutoFocus ? headerRef : ref, tabIndex: accessibilityAutoFocus ? -1 : undefined, className: className, forwardedAs: "h".concat(level) }, props), children));
});
var templateObject_1;
